export default {
  desktop: 1240,
  tablet: 1024,
  tabletSmall: 834,
  mobile: 680,
};
